var _path;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgIconPhoneError = function SvgIconPhoneError(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 39.114 39.119",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.505 36.444l.02.011a9 9 0 0011.2-1.228l1.259-1.259a3 3 0 000-4.245l-5.306-5.3a3 3 0 00-4.245 0h0a3 3 0 01-4.244 0l-8.49-8.492a3 3 0 010-4.245h0a3 3 0 000-4.243l-5.3-5.311a3 3 0 00-4.245 0L3.895 3.391a9.005 9.005 0 00-1.23 11.2l.013.02a81.248 81.248 0 0021.827 21.833z",
    fill: "none",
    stroke: "#762638",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconPhoneError, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/IconPhoneError.a1020eb7.svg";
export { ForwardRef as ReactComponent };